module.exports = __webpack_public_path__ + "static/media/Dev.83bc9674.jpg";